import request from "../../config/axios";

const getWishList = () => {
    return request.get(`/wp-json/custom-favorites/v1/list`, {
        withCredentials: true
    })
}

const addToWishList = (product_id) => {
    return request.post(`/wp-json/custom-favorites/v1/add`, { product_id }, {
        withCredentials: true
    })
}

const removeItemWishList = (product_id) => {
    return request.post(`/wp-json/custom-favorites/v1/remove`, { product_id }, { withCredentials: true })
}

export { getWishList, addToWishList, removeItemWishList }